export default handlers => (
  (state, action) => (
    handlers[action.type](state, action)
  )
)
